<template>
  	<div id="app">
      	<div v-if="$route.path.indexOf('/customer/') >= 0">
		  	<template v-if="$route.path.indexOf('/customer/forgotpassword') != 0 && $route.path.indexOf('/customer/resetpassword') != 0">
        		<customer-header></customer-header>
		  	</template>
        	<div id="wrapper" class="app-sidebar-right">
          		<!-- <customer-sidebar></customer-sidebar> -->
          		<router-view></router-view>
        	</div>
      	</div>
      	<div v-else>
        	<template v-if="$route.path.indexOf('/qrcode/print') >= 0">
            	<router-view></router-view>
        	</template>
        	<template v-else>
          		<app-header></app-header>
          		<div id="wrapper" class="app-sidebar-right admin-dash-view">
            		<app-sidebar></app-sidebar>
            		<router-view></router-view>
          		</div>
        	</template>
      	</div>
  	</div>
</template>

<script>
	import "@babel/polyfill";
    import Header from '@/components/partials/Header';
    import Footer from '@/components/partials/Footer';
    import Sidebar from '@/components/partials/Sidebar';
    import CustomerHeader from '@/components/partials/CustomerHeader';
    import CustomerSidebar from '@/components/partials/CustomerSidebar';
	import EventBus from '../../frontend/src/components/event-bus';
	var contex;

	export default {
		components: {
            'app-header': Header,
            'app-footer': Footer,
            'app-sidebar': Sidebar,
            'customer-header': CustomerHeader,
            'customer-sidebar': CustomerSidebar,
        },
		name: 'App',
		data: () => ({
            showHeader: true,
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
        },
        methods : {

        }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue